<div class="spacing"></div>
<app-navbar></app-navbar>

<router-outlet></router-outlet>